import request from '@/utils/request';
import file from '../router/file';

export default {
  /*
    提交选中的al2列表文件
    **param：canID ，所有选中文件
    * */
  commitA2lChosedFileList(canProjectConfigId, datas, type) {
    return request.post('project/can/saveA2lElement', {
      canProjectConfigId, datas, type,
    });
  },
  /*
  获取解析后通过页数获取A2l文件
  **返回分组列表，观测量数据，标定量数据，当前页面总条数
  * */
  getAllA2l(canProjectId, pageIndex, a2lType, name) {
    // 去除首尾空格
    if (name !== null) {
      name = name.replace(/^\s+|\s+$/g, '');
    }
    return request.post('project/can/getA2lElement', {
      canProjectId, pageIndex, a2lType, name,
    });
  },

  /**
   * 获取所有在线即非在线的文件列表
   */
  getAllFileList() {
    return request.post('file/allFileList');
  },
  /**
   * 条件性获取文件列表
   */
  getCurFileList(currentPage, pageSize, timeOption, searchVal, filterCondition, sortCondition) {
    console.log(currentPage, pageSize, timeOption, searchVal, filterCondition, sortCondition);
    return request.post('file/getFileListByParam', {
      currentPage, pageSize, timeOption, searchVal, filterCondition, sortCondition,
    });
  },
  /**
   * 得到当前条件下的文件列表数量
   */
  getFileListLength() {
    return request.get('file/getFileListLength');
  },
  /**
   * 获取在线以及不在线的设备列表
   */
  getDeviceList() {
    return request.get('file/getDeviceList');
  },
  /**
   * 罗列所有连接的设备
   */
  listDevice() {
    return request.get('device/list');
  },
  /**
   * 得到设备详情
   * @param id 设备id
   * @return {*}
   */
  getDeviceDetail(id) {
    return request.get(`device/${id}/detail`);
  },
  /**
   * 重命名设备
   * @param id 设备id
   * @param newName 新的名字
   * @return {*}
   */
  renameDevice(id, newName) {
    return request.post('device/rename', {
      id,
      name: newName,
    });
  },
  /**
   * 得到设备配置
   * @param deviceId
   * @return {*|Promise<any>}
   */
  getConfig(deviceId) {
    return request.get(`device/${deviceId}/config`);
  },
  /**
   * 更新配置
   * @param deviceId
   * @param data
   * @return {*|Promise<any>}
   */
  setConfig(deviceId, data) {
    return request.post(`device/${deviceId}/config`, data);
  },
  // region 文件相关
  /**
   * 检查当前设备的文件列表是否有更新
   * @param id
   * @return {*}
   */
  checkFileListUpdate(id) {
    return request.post(`device/${id}/file/refresh`);
    // return request.post(`http://mock-api.com/3EgdwXzM.mock/device/${id}/file/refresh`);
  },

  /**
   * 得到与设备相关的文件列表
   * @param id
   * @return {*}
   */
  getDeviceFileList(id) {
    return request.get(`device/${id}/file/list`);
  },
  /**
   * 文件在服务器上，进行下载请求
   * @param id 文件id
   */
  downloadFileFromServer(id) {
    window.location.href = `${process.env.API_ROOT}device/file/download/${id}`;
  },

  /**
   * 文件在服务器上，批量进行压缩
   * @param idList 文件id列表
   * @return 压缩文件的Id
   */
  batchDownloadFileFromServer(idList) {
    const list = JSON.stringify(idList);
    return request.post('device/file/batchDownload', { list });
  },

  /**
   * 批量压缩后，下载压缩文件
   * @param id 压缩文件id
   */
  downloadZipFromServer(zipId) {
    window.location.href = `${process.env.API_ROOT}device/file/download/zip/${zipId}`;
  },

  /**
   * 把文件从设备上上传到服务器
   * @param id 文件id
   */
  downloadFileToServer(id) {
    return request.post('device/file/downloadToServer', { id });
  },
  /**
   * 批量上传文件到服务器
   */
  batchDownloadToServer(idList) {
    const list = JSON.stringify(idList);
    return request.post('device/file/batchDownloadToServer', { list });
  },
  /**
   * 删除设备上的文件，不管文件是在设备还是在服务器上
   * @param id
   * @return {*}
   */
  deleteFile(idList) {
    const ids = JSON.stringify(idList);
    return request.post('device/file/delete', { ids });
  },
  /**
   * 上传文件
   * @param fileBlob
   * @param deviceId
   * @return {*|Promise<any>}
   */
  uploadFile(fileBlob, deviceId) {
    const data = new FormData();
    data.append('file', fileBlob);
    data.append('deviceId', deviceId);
    return request.postForm('device/file/upload', data);
  },
  /**
   * 把一个服务器上的文件，下发至设备
   * @param fileId
   * @return {*|Promise<any>}
   */
  downloadToDevice(fileId) {
    return request.post('device/file/downloadToDevice', {
      id: fileId,
    });
  },
  /**
   * 开始CAN通道对MDF的录制
   * @param deviceId
   * @param canIndex
   * @return {*|Promise<any>}
   */
  startCanPlay(deviceId, canIndex) {
    return request.post(`device/${deviceId}/${canIndex}/startPlay`);
  },

  /**
   * 得到上传文件进度条状态
   * @param filename
   * @return {*|Promise<any>}
   */
  getFileProcess(name) {
    return request.post('downloadToServer/progress', { name });
  },

  /**
   * 停止CAN通道对MDF的录制
   * @param deviceId
   * @param canIndex
   * @return {*|Promise<any>}
   */
  stopCanPlay(deviceId, canIndex) {
    return request.post(`device/${deviceId}/${canIndex}/stopPlay`);
  },

  /**
   * 将Asc文件转为Blf格式
   * @param deviceId
   * @param fileId
   * @return {*|Promise<any>}
   */

  changeAscToBlf(deviceId, fileId) {
    return request.post(`device/file/${deviceId}/${fileId}/changeAscToBlf`);
  },

  touchOffOTA(deviceId, otaId) {
    return request.post(`device/ota/${deviceId}/${otaId}/touchOffBrushing`);
  },
  /**
   * 设置设备的模式
   */
  setDeviceModel(deviceId, model, autoUploadFile, wfAutoUploadFile) {
    const data = new FormData();
    data.append('deviceId', deviceId);
    data.append('unDormancy', model);
    data.append('autoUploadFile', autoUploadFile);
    data.append('wfAutoUploadFile', wfAutoUploadFile);
    return request.postForm('device/config/updateConfig', data);
  },
  /**
   * 根据设备的编号获取刷写票【配置的时候需要调用的函数
   */
  getOTAConfig(deviceId) {
    return request.post(`device/ota/${deviceId}/getConfig`);
  },

  getFileByDeviceIdAndType(deviceId, type) {
    return request.post(`/device/file/${deviceId}/${type}/fileList`);
  },

  /**
   * 添加保存ota配置的api、
   */
  saveOTAConfig(dllFileId, soFileId, s19FileIdd, canIndex, deviceId, baudRate) {
    const data = new FormData();
    data.append('dllFileId', dllFileId);
    data.append('soFileId', soFileId);
    data.append('s19FileId', s19FileIdd);
    data.append('canIndex', canIndex);
    data.append('deviceId', deviceId);
    data.append('baudRate', baudRate);
    return request.postForm('device/ota/saveConfig', data);
  },

  /**
   * 获取通道的OTA历史
   */
  getOTAHistory(deviceId, canIndex) {
    return request.post(`device/ota/${deviceId}/${canIndex}/getHistory`);
  },

  /**
   * 清除条件判断配置
   */
  clearConditionConfig(deviceId) {
    return request.postJson(`/device/clear/${deviceId}/condition/config`);
  },

  /**
   * 更新录制配置
   */
  setRocStatus(deviceId, autoStart) {
    return request.postJson('/device/update/fileRoc/autoStart/status', { deviceId, autoStart });
  },
  /**
   * 获取当前设备的上传文件的状态
   * @param deviceId
   * @returns {Promise<*>}
   */
  getFileUploadStatus(deviceId) {
    return request.postJson(`/device/file/${deviceId}/upload/status`, { deviceId });
  },
  /**
   * 获取OTA进度信息，改为HTTP协议
   * @param deviceId
   * @returns {Promise<*>}
   */
  getOTAProgressHTTP(deviceId) {
    return request.post(`/device/ota/${deviceId}/progress`);
  },
  /**
   * 获取当前OTA状态
   * @param deviceId
   * @returns {Promise<*>}
   */
  getOTAStatusHTTP(deviceId) {
    return request.post(`/device/ota/${deviceId}/status`);
  },
};



// WEBPACK FOOTER //
// ./src/api/device.js